import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

export interface Note {
  _id: string;
  workspaceId: string;
  entityType: string;
  entityId: string;
  title?: string;
  content: string;
  category?: 'general' | 'important' | 'reminder' | 'todo' | 'issue' | 'other';
  priority?: 'low' | 'normal' | 'high' | 'urgent';
  tags?: string[];
  isPinned?: boolean;
  createdBy: string;
  updatedBy: string;
  createdByName?: string;
  updatedByName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateNoteData {
  content: string;
  title?: string;
  category?: string;
  priority?: string;
  tags?: string[];
  isPinned?: boolean;
}

export interface UpdateNoteData {
  content?: string;
  title?: string;
  category?: string;
  priority?: string;
  tags?: string[];
  isPinned?: boolean;
}

// Get all notes for an entity
export const getNotes = async (
  workspaceId: string,
  entityType: string,
  entityId: string
): Promise<Note[]> => {
  const token = localStorage.getItem('token');
  const response = await axios.get(
    `${API_URL}/workspaces/${workspaceId}/${entityType}/${entityId}/notes`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.notes;
};

// Create a new note
export const createNote = async (
  workspaceId: string,
  entityType: string,
  entityId: string,
  data: CreateNoteData
): Promise<Note> => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_URL}/workspaces/${workspaceId}/${entityType}/${entityId}/notes`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.note;
};

// Update a note
export const updateNote = async (
  workspaceId: string,
  noteId: string,
  data: UpdateNoteData
): Promise<Note> => {
  const token = localStorage.getItem('token');
  const response = await axios.put(
    `${API_URL}/workspaces/${workspaceId}/notes/${noteId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.note;
};

// Delete a note
export const deleteNote = async (
  workspaceId: string,
  noteId: string
): Promise<void> => {
  const token = localStorage.getItem('token');
  await axios.delete(
    `${API_URL}/workspaces/${workspaceId}/notes/${noteId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
